import _ from 'underscore';
import pluralize from 'pluralize';

const totalTagsFound = (validStories, tagType) => (
  validStories.reduce((sum, storyToTag) => {
    storyToTag[tagType].forEach((tagGroup) => {
      // eslint-disable-next-line no-param-reassign
      sum += tagGroup.tags.length;
    });
    return sum;
  }, 0)
);

const parseTagGroups = (foundStory, csvTagGroups, publicationTags) => {
  const tagsToAdd = [];
  const invalidTags = [];
  const existingTags = [];

  Object.keys(csvTagGroups).forEach((csvTagGroupName) => {
    const trimmedTagGroup = csvTagGroupName.trim();
    const foundTagGroup = publicationTags.find(
      pt => pt.tagGroup.name === trimmedTagGroup
    );

    if (foundTagGroup) {
      const validTagGroupTags = [];
      const invalidTagGroupTags = [];
      const existingTagGroupTags = [];

      csvTagGroups[csvTagGroupName].split(/[,;\t]+/).forEach((csvTagName) => {
        const trimmedCsvTag = csvTagName.trim();
        const foundTag = publicationTags.find(pt => pt.name === trimmedCsvTag);

        if (foundTag) {
          const foundStoryTag = foundStory.tags.find(
            tag => tag.name === trimmedCsvTag && tag.tagGroup.name === trimmedTagGroup
          );
          if (foundStoryTag) {
            existingTagGroupTags.push(trimmedCsvTag);
          } else {
            validTagGroupTags.push(trimmedCsvTag);
          }
        } else if (trimmedCsvTag.length > 0) {
          invalidTagGroupTags.push(trimmedCsvTag);
        }
      });
      if (validTagGroupTags.length > 0) {
        tagsToAdd.push({ tagGroupName: trimmedTagGroup, tags: validTagGroupTags });
      }
      if (existingTagGroupTags.length > 0) {
        existingTags.push({ tagGroupName: trimmedTagGroup, tags: existingTagGroupTags });
      }
      if (invalidTagGroupTags.length > 0) {
        invalidTags.push({ tagGroupName: trimmedTagGroup, tags: invalidTagGroupTags });
      }
    }
  });
  return {
    tagsToAdd,
    existingTags,
    invalidTags
  };
};

const parseStoryRow = (row, publicationStories, publicationTags) => {
  const { Title, Id, ...csvTagGroups } = row;
  const foundStory = publicationStories.find(publicationStory => (
    publicationStory.title.trim() === Title.trim() && publicationStory.id.trim() === Id.trim()
  ));

  if (foundStory) {
    const parsedTagGroups = parseTagGroups(
      foundStory,
      csvTagGroups,
      publicationTags
    );

    const { tagsToAdd, existingTags, invalidTags } = parsedTagGroups;

    return {
      found: true,
      storyTitle: Title,
      storyId: Id,
      tagsToAdd,
      existingTags,
      invalidTags
    };
  }
  return {
    found: false,
    storyTitle: Title,
    storyId: Id
  };
};

const parseCsv = (csv, publicationStories, publicationTags) => {
  const headers = Object.keys(csv[0]);
  const csvTagGroupNames = _.without(headers, 'Title', 'Id');
  const pubTagGroupNames = _.uniq(publicationTags.map(pt => pt.tagGroup.name.trim()));
  const invalidTagGroupNames = csvTagGroupNames.filter(
    tgn => !pubTagGroupNames.includes(tgn.trim())
  );

  const validStories = [];
  const unfoundStories = [];

  csv.forEach((row) => {
    const storyRow = parseStoryRow(
      row,
      publicationStories,
      publicationTags
    );

    if (storyRow.found) {
      validStories.push(storyRow);
    } else {
      unfoundStories.push(storyRow);
    }
  });

  const totalTagsToAdd = totalTagsFound(validStories, 'tagsToAdd');
  const totalExistingTags = totalTagsFound(validStories, 'existingTags');
  const totalinvalidTags = totalTagsFound(validStories, 'invalidTags');

  const parsedCsv = {
    totalTagsToAdd,
    totalExistingTags,
    totalinvalidTags,
    validStories,
    unfoundStories,
    invalidTagGroupNames
  };

  if (totalTagsToAdd === 0) {
    parsedCsv.invalidMessage = 'There are no valid tags to add from this csv. Please check your csv and try again.';
  }

  return parsedCsv;
};

const validateCsv = (csv, publicationStories, publicationTags) => {
  if (csv.length === 0) {
    return {
      invalidMessage: 'This csv is empty. Please try again with a different file.'
    };
  }

  const headers = Object.keys(csv[0]);
  if (!_.isEqual(_.take(headers, 2), ['Title', 'Id'])) {
    return {
      invalidMessage: 'This csv does not have the correct headers. Please see the example csv.'
    };
  }
  return parseCsv(csv, publicationStories, publicationTags);
};

const renderPluralized = (object, number) => (
  pluralize(object, number)
);

const renderStoriesByTagType = (stories, tagType) => (
  pluralize('story', stories.filter(story => story[tagType].length > 0).length)
);

export { validateCsv, renderPluralized, renderStoriesByTagType };



// WEBPACK FOOTER //
// ./app/javascript/app/components/admin2/bulk_story_tagging/csv_helpers.js